export class TransactionTypeSwitch {
    constructor(container) {
        this.container = container;
        this.hiddenInput = container.querySelector('input[type="hidden"]');
        this.links = container.querySelectorAll('.nav-link');
        
        this.init();
    }
    
    init() {
        this.links.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectOption(link);
            });
        });
    }
    
    selectOption(selectedLink) {
        // Remove active class from all links
        this.links.forEach(link => link.classList.remove('active'));
        
        // Add active class to selected link
        selectedLink.classList.add('active');
        
        // Update hidden input value
        const value = selectedLink.getAttribute('value');
        if (this.hiddenInput) {
            this.hiddenInput.value = value;
        }
        
        // Dispatch change event
        this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    getValue() {
        return this.hiddenInput ? this.hiddenInput.value : '';
    }
}